/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, IconButton } from '@material-ui/core';
import CallIcon from '@mui/icons-material/Call';
import Avatar from '@material-ui/core/Avatar';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import firebase from "../../config/firebase/index";


import style from './style';
import encSecret from '../../config/encryption';
import MessageAtom from '../MessagAtom';
var CryptoJS = require("crypto-js");


function ButtonAtom(props) {
    const classes = style();
    const dealId = props.dealId;
    const [customers, setCustomers] = useState([]);
    const [more, setMore] = useState(true);
    let phoneLink = "";
    let whatsappLink = "";

    useEffect(() => {
        console.log(":::: :::: ::: ", dealId);
        currentDeal();

    }, []);

    const currentDeal = () => {

        firebase.database().ref("Customer").orderByChild("DealId")
            .equalTo(dealId).once("value", snapshot => {

                const customerData = snapshot.val();
                // const user = userData;

                const customers = [];
                for (const key in customerData) {

                    const quoteObj = {
                        id: key,
                        ...customerData[key],
                    };
                    if (quoteObj.method === "suggest") {
                        customers.push(quoteObj);
                    }
                }
                setCustomers(customers);
                console.log("::: ", customerData, customers);
                phoneLink = "tel:" + customers.PhoneNo;
                whatsappLink = "https://wa.me/91" + customers.PhoneNo;


            })
    }

    const formatDate = (DATE) => {
        let d = DATE.split(" ");
        let dd = d[0].split("-");
        let newDATE = dd[1] + "/" + dd[2] + "/" + dd[0] + " " + d[1];
        console.log("NDATE ::: ", newDATE);
        let nDate = new Date(newDATE);

        console.log("::: :", nDate);
        let dateArr = nDate.toString().split(" ");
        let hrs = nDate.getHours();
        let mnts = nDate.getMinutes();
        let AMPM = hrs >= 12 ? 'PM' : 'AM';
        hrs = hrs % 12;
        hrs = hrs ? hrs : 12;
        mnts = mnts < 10 ? '0' + mnts : mnts;
        var result = dateArr[2] + " " + dateArr[1] + " " + hrs + ':' + mnts + ' ' + AMPM;
        return result;
        // return nDate.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric', hour12: true })
    }

    return (
        <Grid className={classes.contactListSection}>
            {customers && customers.map((customer, index) => (
                <Grid key={index} className={classes.contentBox}>
                    <Box className={`${classes.oneByOne}`} p={1} pt={2} style={{background: customer.dealSuggestType && customer.dealSuggestType === "sale" ? "rgba(223, 91, 74, 0.25)" : "rgba(109, 163, 87, 0.25)"}}>
                        {/* <Box>
                            <Typography variant="h5">₹</Typography>
                        </Box> */}
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <Box ml={0.5} mr={1} >
                                <Avatar sx={{ width: '130px', height: '130px', }} className={classes.image} alt="farmer" src={customer.img} /><br/>
                                <Typography style={{fontWeight: 600, marginTop: "-20px", fontSize:12, paddingLeft: 5}}>{customer.dealSuggestType && customer.dealSuggestType == "sale" ? "Seller" : "Buyer"}</Typography>
                            </Box>
                            <Box style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Typography variant="caption">
                                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                                        {customer.Name == "Unknown" ? customer.Name : CryptoJS.AES.decrypt(customer.Name, encSecret.key).toString(CryptoJS.enc.Utf8)}
                                    </div>
                                    <div style={{ marginTop: "-5px", fontSize: 10 }}>
                                        {formatDate(customer.time)}
                                    </div>
                                </Typography>
                                <Typography variant="caption">
                                    <div style={{paddingLeft: 5}}>
                                        <div style={{ fontSize: 14, fontWeight: 600 }}>
                                            Rs.{customer.price}
                                            <span style={{ fontSize: 10, fontWeight: 500 }}>/{customer.quantityUnit}</span>
                                        </div>
                                        <div style={{ marginTop: "-5px" }}>
                                            {customer.quantity}
                                        </div>
                                    </div>

                                </Typography>
                                {/* <Typography variant="caption"></Typography> */}
                            </Box>

                            <Box className={classes.mlAuto}>
                                <a href={"tel:" + customer.PhoneNo}>

                                    <CallIcon />
                                </a>
                                {/*  */}
                            </Box>

                        </div>
                        <div style={{textAlign: "justify"}}>
                            <Box>
                                <Box m={1}>
                                    <Typography variant="caption" style={{fontWeight: 600}}>
                                        व्यापारी द्वारा संदेश
                                    </Typography><br />
                                    <MessageAtom message={customer.message} len={150} />
                                </Box>
                            </Box>
                        </div>
                    </Box>

                </Grid>
            )).reverse()}
        </Grid>
    );
}



export default ButtonAtom;